<template>
   <div class="demo-chart-wrapper">
      <div class="row demo-chart-row">
         <div class="col-12 demo-chart">
            <h2 class="custom-h3 demo-chart__header">Interactive examples and Code Snippets</h2>
            <mq-layout :mq="['xs', 'sm', 'md', 'lg']">
               <div class="demo-chart__dropdown">
                  <BaseModalSelect
                     v-model="selectedTabIndex"
                     class="chart-selector"
                     :options="tabOptions"
                     placeholder="Quick demo"
                  />
               </div>
            </mq-layout>
            <mq-layout mq="xl+">
               <ul class="demo-chart__tabs">
                  <li
                     v-for="(item, index) in details.tabs"
                     :key="index"
                     class="demo-chart__tabs__tab"
                     :class="{ active: selectedTabIndex == index }"
                     @click="changeTab(index)"
                  >
                     <div class="special-icon">
                        <i class="tab-icon" :class="item.className"></i>
                        <span>{{ item.header }}</span>
                     </div>
                  </li>
               </ul>
            </mq-layout>

            <div class="demo-chart__chart">
               <ChartView
                  :js-code="currentChart.code.jsCode"
                  :html-code="currentChart.code.htmlCode"
                  :css-code="currentChart.code.cssCode"
                  :seo-img-url="currentChart.preview"
                  :seo-img-alt="currentChart.header"
                  :product="product"
                  @themechanged="selectTheme"
               />
            </div>
            <div v-if="isClient">
               <mq-layout mq="xs">
                  <CodeViewSm
                     :display="currentChart.code.display"
                     :code="currentChart.code"
                     :is-static="true"
                     :selected-theme="selectedTheme"
                  />
               </mq-layout>
               <mq-layout mq="sm+">
                  <CodeView
                     :display="currentChart.code.display"
                     :is-static="true"
                     :show-file-tabs="true"
                     :selected-theme="selectedTheme"
                     :code-details="codeViewDetails"
                  />
               </mq-layout>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import Queue from 'promise-queue';

export default {
   name: 'DemoChart',
   components: {
      ChartView: () => import('../playground/ChartView'),
      CodeView: () => import('../playground/CodeView'),
      CodeViewSm: () => import('../playground/CodeViewSm'),
      BaseModalSelect: () => import('../core/BaseModalSelect'),
   },

   props: {
      details: {
         type: Object,
         default: () => {},
      },
      stack: {
         type: String,
         default: '',
      },
      language: {
         type: String,
         default: '',
      },
      tabOptions: {
         type: Array,
         default: () => [],
      },
      codeViewDetails: {
         type: Object,
         default: () => {},
      },
      method: { type: Function, default: Function },
   },

   data() {
      return {
         selectedTabIndex: '0',
         selectedTheme: null,
         currentChart: this.details.tabs[0],
         tabServiceQueue: new Queue(1, Infinity),
         product: null,
         isClient: false,
      };
   },

   watch: {
      details() {
         [this.currentChart] = this.details.tabs;
      },
      $route(to) {
         this.selectedTabIndex = '0';
      },

      currentChart(val) {
         this.product = val.product;
      },
      selectedTabIndex(val) {
         if (this.details.tabs[val].code) {
            this.currentChart = this.details.tabs[val];
            return;
         }
         this.tabServiceQueue.add(this.getCode);
      },
   },

   mounted() {
      this.isClient = true;
   },

   methods: {
      changeTab(index) {
         this.selectedTabIndex = index;
      },
      async getCode() {
         try {
            this.$bar.start();
            await this.$store.dispatch('INTEGRATIONS_PAGE_CODE_FETCH', {
               stack: this.stack,
               language: this.language,
               tab: this.selectedTabIndex,
            });
            if (
               this.details &&
               this.details.tabs &&
               this.details.tabs.length &&
               this.details.tabs[this.selectedTabIndex].code
            ) {
               this.currentChart = this.details.tabs[this.selectedTabIndex];
            }
            this.$bar.finish();
         } catch (error) {
            this.$bar.fail();
            this.$bar.finish();
         }
      },
      selectTheme(theme) {
         this.selectedTheme = theme;
      },
   },
};
</script>

<style lang="scss" scoped>
.demo-chart-wrapper {
   .demo-chart-row {
      margin: 0;
      .demo-chart {
         padding: 0;
         &__header {
            letter-spacing: 0.43px;
            line-height: 38px;
            padding-bottom: 24px;
            margin: 0;
         }
         &__tabs {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            justify-content: center;
            padding-bottom: 11.99px;
            &__tab {
               padding: 11.99px 11px;
               background-color: #ffffff;
               box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
               border-radius: 4px;
               margin: 0 11.99px;
               color: #434456;
               font-size: 15px;
               line-height: 16px;
               cursor: pointer;
               font-weight: 600;
               &:hover {
                  background: linear-gradient(270deg, #5b72de 0%, #745ff9 100%);
                  color: #ffffff;
                  & .tab-icon {
                     color: #ffffff;
                  }
               }
               .special-icon {
                  display: flex;
                  align-items: center;
               }
               .tab-icon {
                  font-size: 19px;
                  padding-right: 10px;
                  vertical-align: text-bottom;
               }
            }
            .active {
               background: linear-gradient(270deg, #5b72de 0%, #745ff9 100%);
               color: #ffffff !important;
            }
         }
         .demo-chart__dropdown {
            padding-bottom: 11.99px;
            display: flex;
            justify-content: center;
         }
      }
   }
}
</style>
